import { View } from 'react-native'
import Animated, {
  interpolate,
  interpolateColor,
  SharedValue,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from 'react-native-reanimated'
import { useEffect } from 'react'
import { colors } from '@ui/colors'

type Props = {
  value: boolean
  colorActive?: string
}

const container = 32
const outer = 28
const border = 3
const inner = outer - 4 * border

export const RadioIcon = ({
  checked,
  colorActive = colors.text,
  error,
}: {
  error?: SharedValue<number>
  checked: SharedValue<number>
  colorActive?: string
}) => {
  const iconStyle = useAnimatedStyle(() => {
    let color = interpolateColor(
      checked.value,
      [0, 1],
      [colors.white0, colorActive]
    )

    if (typeof error !== 'undefined') {
      color = interpolateColor(error.value, [0, 1], [color, colors.red[600]])
    }

    return {
      opacity: interpolate(checked.value, [0, 1], [0, 1]),
      transform: [
        {
          scale: interpolate(checked.value, [0, 1], [0, 1]),
        },
      ],
      backgroundColor: color,
    }
  })

  const borderStyle = useAnimatedStyle(() => {
    let color = interpolateColor(
      checked.value,
      [0, 1],
      [colors.text, colorActive]
    )

    if (typeof error !== 'undefined') {
      color = interpolateColor(error.value, [0, 1], [color, colors.red[600]])
    }
    return {
      borderWidth: border,
      borderColor: color,
    }
  })

  return (
    <View
      className="flex items-center justify-center "
      style={{ width: container, height: container }}
    >
      <Animated.View
        className="flex items-center justify-center rounded-full"
        style={[
          borderStyle,
          {
            width: outer,
            height: outer,
          },
        ]}
      >
        <Animated.View
          className="rounded-full bg-gray-900"
          style={[iconStyle, { width: inner, height: inner }]}
        />
      </Animated.View>
    </View>
  )
}

export default function Radio({ value, colorActive }: Props) {
  // const { animation, onPressIn, onPressOut } = useAnimatedPress({
  //   duration: 300,
  // })

  const checked = useSharedValue(value ? 1 : 0)

  useEffect(() => {
    checked.set(withSpring(value ? 1 : 0))
  }, [value])

  return <RadioIcon checked={checked} colorActive={colorActive} />
}
